import React, { useEffect, useState } from "react";
import api from "../api";
// import '../contactus.css'
import Avatar from "../static/images/avata.svg";
import VerifyOTP from "./ServiceBot/OTPVerify";
const productList = [
    { className: "term", dispalyValue: "Health Insurance", key: "2" },
    { className: "health", dispalyValue: "Term Insurance", key: "7" },
    { className: "motor", dispalyValue: "Motor Insurance", key: "117" },
    { className: "travel", dispalyValue: "Travel Insurance", key: "3" },
    { className: "tw", dispalyValue: "2 Wheeler Insurance", key: "114" },
    { className: "saving", dispalyValue: "Investment Plan", key: "115" }
]



export default function PbWebChat({ userToken,
    setInitialized,
    isService,
    setService,
    OPTVerified,
    setVerifyied,
    productId,
    selectProductId,
    isSales,
    setSales,
    setConnected,
    setRegistered,
    restartChat,
    inputType,
    setInputType,
    maskedMobileNo,
    setMaskedMobileNo,
    verifyOTP,
    setVerifyOTP,
}) {
    const [currentMessage, setCurrentMessage] = useState(0);
    const [showLoader, setShowLoader] = useState(true);
    const messages = [
        "Setting Up Your Chat",
        "Initializing Chat Interface"
    ];

    useEffect(() => {
        const messageTimer = setTimeout(() => {
            setCurrentMessage(1);
        }, 1500);
        
        const serviceTimer = setTimeout(() => {
            setService(true);
            setShowLoader(false);
        }, 3000);
        
        return () => {
            clearTimeout(messageTimer);
            clearTimeout(serviceTimer);
        };
    }, []);

    useEffect(() => {
        if (isService) {
            console.log('isService updated:', isService);
            restartChat()
        }

    }, [isService]);

    useEffect(() => {
        if (OPTVerified) {
            if (isService || (isSales && productId)) {
                // setInitialized(false)
                // setConnected(false)
                // setRegistered(false)
                restartChat()
            }
        }
    }, [isService, isSales, productId, OPTVerified])

    const miniMize = (e) => {
        // e.preventDefault();
        console.log("minimizing ini");
        if (window && window.parent) {
            console.log("minimizing start");
            window.parent.postMessage({ message: 'Box minimize.', minimize: true }, '*');
        } else {
            console.log("minimizing not  start");
        }
        // GAEvent({eventAction:"Chat-Minimizes",eventLabel: "Click-Chat-Minimizes"})
    }


    return (
        <div id="container" className={`${(isSales || isService) && !OPTVerified ? "" : 'lightblue'}`}>

            <div id="chat-frame" className={`${(isSales || isService) && !OPTVerified ? "mini" : ''}`}>
                <header>
                    <span onClick={() => miniMize()} class="close"></span>
                    <div class="heading-with-icon">
                        <img src={Avatar} class="chaticon"></img>
                        <div class="titlewrap">
                            <div class="title">Welcome to PB Chat</div>
                        </div>
                    </div>
                </header>
                {showLoader && (
                    <div style={{textAlign: 'center', padding: '40px', marginTop: '60px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '12px', margin: '20px'}}>
                        <div style={{display: 'inline-block', width: '50px', height: '50px', border: '3px solid rgba(52, 152, 219, 0.2)', borderTop: '3px solid #3498db', borderRadius: '50%', animation: 'spin 0.6s linear infinite', marginBottom: '25px'}}></div>
                        <h3 style={{fontSize: '18px', color: '#2c3e50', margin: '0 0 10px 0', fontWeight: '600'}}>{messages[currentMessage]}</h3>
                        <p style={{fontSize: '14px', color: '#7f8c8d', margin: '0', lineHeight: '1.5'}}>Preparing your personalized chat experience...</p>
                        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                    </div>
                )}
                
                {/* {isSales && OPTVerified ? null :
                    <div class="content">
                        <h3>How can we help you?</h3>
                        <div class="faq-landing">
                            <ul class="faq">
                                <li><a onClick={() => setSales(true)}>Buy insurance policy<span class="arrow"></span></a></li>
                                <li><a onClick={() => setService(true)} class="needhelp">Need help with an existing policy<span class="arrow"></span></a></li>
                            </ul>
                        </div>
                    </div>}
                {(isSales || isService) && !OPTVerified ?
                    <VerifyOTP
                        isSales={isSales}
                        isService={isService}
                        userToken={userToken}
                        setInitialized={setInitialized}
                        OPTVerified={OPTVerified}
                        setVerifyied={setVerifyied}
                        inputType={inputType}
                        setInputType={setInputType}
                        maskedMobileNo={maskedMobileNo}
                        setMaskedMobileNo={setMaskedMobileNo}
                        verifyOTP={verifyOTP}
                        setVerifyOTP={setVerifyOTP}
                    /> : null
                }
                {isSales && OPTVerified ?
                    <div class="content">
                        <h3>Please Select a product</h3>
                        <div class="faq-landing-icon">
                            <ul class="faq">
                                {productList.map((item) =>
                                    <li><a className={item.className} onClick={() => selectProductId(item.key)}>{item.dispalyValue}<span class="arrow"></span></a></li>
                                )}
                            </ul>
                        </div>
                    </div> : null} */}
            </div>

        </div>

    );
}
